/* eslint-disable global-require */
/* eslint-disable import/prefer-default-export */
import { Country } from '@configs/language';
import { Countries } from '@constants/enums';
import { ShepherdOptionsWithType, Tour } from 'react-shepherd';

export const tourOptions: Tour.TourOptions = {
  defaultStepOptions: {
    classes: '',
    scrollTo: { behavior: 'smooth', block: 'center' },
    modalOverlayOpeningPadding: 4,
    canClickTarget: false,
  },
  useModalOverlay: true,
};

const stepButtons = (t: (key: string) => string) => [
  {
    classes: 'cancel-btn p-0',
    text: t('tutorialSkip'),
    type: 'cancel',
  },
  {
    classes: 'next-btn',
    text: t('tutorialBtnNext'),
    type: 'next',
  },
];

export const steps = (t: (key: string) => string, country: Country) =>
  [
    {
      id: 'intro',
      attachTo: {
        element: '.first-step',
        on: 'bottom',
      },
      text: [
        `<h4 class="mb-3">${t('tutorialStep1Header')}</h4><p class="mb-4">${t(
          'tutorialStep1Description'
        )}</p>${
          country === Countries.USA
            ? `<p class="mb-4">${t('tutorialStep1Description2')}</p>`
            : ''
        }`,
      ],
      buttons: stepButtons(t),
    },
    {
      id: 'balance',
      attachTo: {
        element: '.balance-step',
        on: 'bottom',
      },

      text: [`<p class="mb-4">${t('tutorialStepBalanceDescription')}</p>`],
      showOn: () => country === Countries.USA,
      buttons: stepButtons(t),
    },
    {
      id: 'convert',
      attachTo: {
        element: '.convert-step',
        on: 'bottom',
      },
      text: [
        `<h4 class="mb-3">${t(
          'tutorialStepConvertHeader'
        )}</h4><p class="mb-4">${t('tutorialStepConvertDescription')}</p>`,
      ],
      buttons: stepButtons(t),
    },
    {
      id: 'second',
      attachTo: {
        element: '.second-step',
        on: 'bottom',
      },
      text: [
        `<h4 class="mb-3">${t('tutorialStep2Header')}</h4><p class="mb-4">${t(
          'tutorialStep2Description'
        )}</p>`,
      ],
      buttons: stepButtons(t),
    },
    {
      id: 'fourth',
      attachTo: {
        element: '.fourth-step',
        on: 'bottom',
      },
      text: [
        `<h4 class="mb-3">${t('tutorialStep4Header')}</h4><p class="mb-4">${t(
          'tutorialStep4Description'
        )}</p>`,
      ],
      buttons: stepButtons(t),
    },
    {
      id: 'fifth',
      attachTo: {
        element: '.fifth-step',
        on: 'right',
      },
      text: [
        `<h4 class="mb-3">${t('tutorialStep5Header')}</h4><p class="mb-4">${t(
          'tutorialStep5Description'
        )}</p>`,
      ],
      buttons: stepButtons(t),
    },
    {
      id: 'last',
      classes: 'third-step',
      text: [
        `<h4 class="mb-3">${t('tutorialStep3Header')}</h4><p class="mb-4">${t(
          'tutorialStep3Description'
        )}</p>`,
      ],
      buttons: [
        {
          classes: 'cancel-btn p-0',
          text: t('tutorialSkip'),
          type: 'cancel',
        },
        {
          classes: 'next-btn',
          text: t('tutorialBtnEnd'),
          type: 'next',
        },
      ],
    },
  ] as ShepherdOptionsWithType[];
